module.exports = "<div class=\"accounts-offices-content-container\" ng-controller=\"OfficesController as offices\">\n    <ng-include src=\"'app/accounts/offices/officesTable/officesTable.html'\" ng-if=\"!offices.isEditingOffice\"></ng-include>\n    <ng-include src=\"'app/accounts/offices/officeDetail.html'\" ng-if=\"offices.isEditingOffice\"></ng-include>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/offices/offices.html
// module id = 483
// module chunks = 1